import { cx } from '@mage-ui/styled-system/css';
import { detailInnerSection } from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { GoToCta } from '../../navigation/ctas/GoToCta';
import { DetailInnerSectionHeading } from './section-headings/DetailInnerSectionHeading';

export const DetailInnerSection = ({
	heading,
	children,
	anchor,
	anchorSlot,
	sectionId,
	isRelation,
	className,
	...props
}) => {
	const { st } = useContext(StaticTextContext);

	const renderAnchor =
		anchorSlot ??
		(anchor?.link && anchor?.text ? (
			<GoToCta text={anchor.text || st('body.goto')} slug={anchor.link} />
		) : null);

	return (
		<section className={cx(detailInnerSection().root, className)} {...props}>
			<DetailInnerSectionHeading data={heading} isRelation={isRelation} />
			<div className={detailInnerSection().content}>{children}</div>
			{renderAnchor && (
				<div className={detailInnerSection().goto}>{renderAnchor}</div>
			)}
		</section>
	);
};
